var layout_default = {
  "layoutWrapper": "uwc9i",
  "layout": "j8W9q",
  "designOnLayout": "JhEIF",
  "designOnCell": "YnUiD",
  "cell": "_3EXUu",
  "mobile": "j--n9"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
